import { Link, useRouteMatch } from 'react-router-dom';
import { TabButton } from './styled';
export function PageTab(props) {
    const { path, children } = props;
    const active = useRouteMatch(path);
    const isActive = Boolean(active);
    return (<TabButton as={Link} to={path} $active={isActive} data-active={isActive}>
      {children}
    </TabButton>);
}
